import { roomMeta, stayQuote, villa } from '../data';
import { formatLongDate, formatPrice, nightsBetween, nightsLabel, occupancyLabel } from '../utils';

export default function StaySummary({ search, room }) {
  const nights = nightsBetween(search.checkIn, search.checkOut) || 1;
  const meta = roomMeta(room);
  const quote = stayQuote(room, nights);
  const hasDates = Boolean(search.checkIn && search.checkOut);

  return (
    <aside className="reserve-box stay-summary">
      <img src={room.images[0]} alt="" />
      <p className="stay-bar-kicker">Your stay</p>
      <h2>{room.name}</h2>
      <p className="price-note">{meta.beds} · Sleeps {meta.sleeps}</p>
      <ul className="summary-facts">
        <li>
          <span>Dates</span>
          <strong>
            {hasDates
              ? `${formatLongDate(search.checkIn)} – ${formatLongDate(search.checkOut)}`
              : 'Confirmed at booking'}
          </strong>
        </li>
        <li>
          <span>Length</span>
          <strong>{nightsLabel(nights)} · {occupancyLabel(search.occupancy)}</strong>
        </li>
        <li>
          <span>Times</span>
          <strong>In from {villa.checkIn} · Out by {villa.checkOut}</strong>
        </li>
      </ul>
      <ul className="price-break">
        <li>
          <span>{nightsLabel(nights)} × {formatPrice(room.price)}</span>
          <span>{formatPrice(quote.total)}</span>
        </li>
        <li>
          <span>Taxes and charges</span>
          <span>Included</span>
        </li>
        <li className="is-total">
          <span>Total</span>
          <span>{formatPrice(quote.total)}</span>
        </li>
      </ul>
      <p className="summary-policy">Free cancellation until 24 hours before arrival. Pay at the villa. A card is held as guarantee.</p>
    </aside>
  );
}
